<template>
    <div class="m-0">
        <b-card>
            <div class="row">
                <!-- <div class="col-7"> -->
                <div class="col-12">
                    <!-- <p class="card-text">
                    <b>{{ hotel.hotel }}</b><br>
                    <small>{{ hotel.pobla }}</small>
                    </p> -->
                    <div class="form-group">
                        <label class="text-small">Destinos / Hoteles</label>
                        <!-- <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0" v-model="todos">Destinos / Hoteles</b-form-checkbox> -->
                         <!-- {{ hot }} -->
                        <b-form-select v-model="hot"
                            :options="hoteles" value-field="hot" text-field="hotel"
                            @change="hotel_precios"
                            class="mb-1"
                        />
                        <p class="text-primary ml-2" v-if="hot>'0'"><small>{{ pob }}</small></p>
                    </div>
                </div>
                <!-- <b-icon variant="success" icon="cart3"></b-icon> -->
               <!--  <div class="col-5">
                    <div class="form-group">
                        <label class="text-small">Salidas / Transporte</label>
                        <b-form-select v-model="sal"
                            :options="salidas"
                            class="mb-1"
                        ></b-form-select>
                    </div>
                </div> -->
            </div>
            <b-table striped hover sticky-header="440px" head-variant="light"
                :items="turnosFiltrados" :fields="hot>'0' ? turnos.fields : turnos.fields0"
                class="table-responsive-md bg-white" responsive="sm">

                <template slot="cell(hotel)" slot-scope="{item: { hotel }}">
                    <small>{{ hotel }} </small>
                </template>

                <template #cell(action)="data">
                    <b-btn size="lg" variant="light" class="p-0" v-if="data.item.lib<=0">
                        <!-- <b-icon variant="danger" icon="x-square"></b-icon> -->
                        <b-icon variant="danger" icon="cart2"></b-icon>
                    </b-btn>
                    <b-btn size="md" variant="success" class="p-1" v-else @click="selecciona(data)">
                        <b-icon icon="cart4" class="mr-1"></b-icon>
                        <b-badge variant="primary" class="mr-1">{{data.item.lib3}}</b-badge>
                        <b-badge variant="warning" class="mr-1">{{data.item.lib2}}</b-badge>
                        <b-badge variant="dark">{{data.item.lib1}}</b-badge>
                    </b-btn>
                </template>

            </b-table>
            <!-- <p><small>Periodos </small> <b> {{turnos.items.length}} </b></p> -->
        </b-card>
        <div class="row mx-1 pl-2 mt-0 bg- text-faded">
            <div class="col-4">Periodos <b>{{turnosFiltrados.length}}</b></div>
            <div class="col-8">
                <b-icon variant="success" icon="cart4"></b-icon> Reserva &nbsp;
                <b-icon variant="primary" icon="circle-fill"/><small>Doble</small>
                <b-icon variant="warning" icon="circle-fill"></b-icon><small>Doble Comp.</small>
                <b-icon variant="dark" icon="circle-fill"></b-icon><small>Individual</small>
                <!-- <b-icon variant="danger" icon="x-square" class="ml-4"></b-icon> Sin disponibilidad -->
                &nbsp;<b-icon variant="danger" icon="cart2" class="ml-4"></b-icon><small>Sin Disponibilidad</small>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'hotelDispo',

    data() {
        return {
            hotel: {},
            hot: '',
            pob: '',
            sal: '',
            //salidas: [],
            todos: false,
        }
    },

    async created() {
        console.log('hotel_dispo****created',this.hot,this.hotel,this.hoteles,this.turnos);
        //if (this.hot>'') return;
        this.hot=(this.hotel.hot>0 ? this.hotel.hot : this.hoteles[0].hot);

        await this.hotel_precios(this.hot);
    },

    computed: {
        hoteles() {
            let H=Array.from(this.$store.state.hoteles.hoteles);
            H.unshift({hot:0,hotel:'*Todos (Selecciona)'})
            return H;
        },
        turnos() {
            return this.$store.state.hoteles.turnos;
        },

        /* hotel() {
            return this.$store.state.hoteles.hotel;
        }, */
        /* turno() {
            return this.$store.state.hoteles.turno;
        }, */

        turnosFiltrados() {
            // var H=this.$util.object_array(this.turnos.items);
            var H=this.turnos.items;
            if (this.sal>'') {
                H = H.filter(item => item.sal.indexOf(this.sal) != -1);
            }
            //return this.$util.array_object(H);
            return H;
        },
        reserva() {
            return this.$store.state.reserva;
        },

        // salidas() { console.log('salidas',this.sal,this.turnos);
        //     // let result=this.$util.object_array(this.turnos.items);
        //     let result=this.turnos.items;

        //     var A=[{text:"Selecciona Transporte", value:'', disabled:false}];
        //     result.forEach(value => {
        //         let txt=(value.sal=='*SIN TRANSPORTE'?'* Sin Transporte':"BUS - "+value.sal);

        //         let names = A.map(e => e.value);
        //         //console.log(names.includes(value.sal)); // returns true
        //         if (!names.includes(value.sal))
        //             A.push({text:txt, value:value.sal, disabled:false});
        //     });

        //     return A;
        // },

    },
    methods: {

        async hotel_precios(item='') {
            if (item=='') item=this.hot;

            //buscamos en hoteles
            let index = await this.hoteles.map((o) => o.hot).indexOf(item);
            this.hotel =this.hoteles[index];
            console.log('*hotel_dispo.hotel_precios',this.hoteles,item,index,this.hotel);

            await this.$store.dispatch('hotel_precios', this.hotel);

            //this.salidas=this.hotel_salidas();

            this.hot=item;
            this.pob=this.hotel.pobla + " -  " + this.hotel.zon;
            //this.sal=this.salidas[0].value;
        },

        /* hotel_salidas() {
            // let result=this.$util.object_array(this.turnos.items);
            let result=this.turnos.items;

            var A=[{text:"Selecciona Transporte", value:'', disabled:false}];
            result.forEach(value => {
                let txt=(value.sal=='*SIN TRANSPORTE'?'* Sin Transporte':"BUS - "+value.sal);

                let names = A.map(e => e.value);
                //console.log(names.includes(value.sal)); // returns true
                if (!names.includes(value.sal))
                    A.push({text:txt, value:value.sal, disabled:false});
            });
            console.log("*selecciona",item.item.id,this.$store.state.hoteles.turno);

            return A;
        }, */

        selecciona(item) {
            this.$store.state.hoteles.hotel=this.hotel;
            //item.item.hotel=this.hotel.hotel;
            this.$store.state.hoteles.turno=item.item;

            //reserva
            this.reserva.hot=item.item.hot;
            this.reserva.fhe=item.item.fhe; this.reserva.fhs=item.item.fhs; this.reserva.noc=item.item.noc;
            this.reserva.pre=item.item.pre;
            this.reserva.turno=item.item.id;
            this.reserva.reg='PC'; //itm.item.reg;

            // abrimos reserva sino ...
            if (this.$route.name!='reserva') this.$router.push('/reserva');
            this.close();
        },

        close() {
            this.$bvModal.hide('modal_hotelDispo');
        }
    }
}
</script>
